import { Dispatch, SetStateAction } from "react";
import { Box, MenuItem, Select } from "@mui/material";
import clsx from "clsx";
import SelectorChevron from "@/assets/icons/header/SelectorChevron";

const SelectorIcon = (props: { className: string }) => {
	const isOpen = props.className.includes("MuiSelect-iconOpen");
	return (
		<SelectorChevron
			className={clsx("relative right-7 text-default !text-[#666]", {
				"rotate-180": isOpen,
			})}
		/>
	);
};
interface ISelectorProps {
	data: string[];
	selectedIndex: number;
	setSelectedIndex: Dispatch<SetStateAction<number>>;
}
export function TimePeriodSelector({ selectedIndex, setSelectedIndex, data }: Readonly<ISelectorProps>) {
	return (
		<Box className="relative pt-0 !h-4">
			<Select
				value={selectedIndex}
				label="Time Period"
				onChange={(e) => setSelectedIndex(Number(e.target.value))}
				className="-top-[5px] [&>fieldset]:hidden !text-[13.5px] !font-medium"
				IconComponent={SelectorIcon}
				MenuProps={{
					className: "!max-h-[300px]",
					anchorOrigin: {
						horizontal: "right",
						vertical: "bottom",
					},
					transformOrigin: {
						horizontal: "right",
						vertical: "top",
					},
					slotProps: {
						paper: {
							className: "pt-[7px] pb-[10px] mt-[5px] !shadow-menu-gray",
						},
					},
					MenuListProps: {
						className: "!px-0 !py-0",
					},
				}}
				inputProps={{
					className: "!font-montserrat !text-[#666] text-[13.5px]/[16.5px] !h-4 !p-0 !m-0 !pr-7",
				}}
				SelectDisplayProps={{
					className: "!p-0 !m-0",
				}}
			>
				{data?.map((item, i) => (
					<MenuItem
						key={`${item}_${i}`}
						value={i}
						className={clsx("!py-[5px] !px-3 !min-w-20 !text-[12px] !font-montserrat !font-medium !text-[#666] ", {
							"!bg-gray-highlight !text-white": i === selectedIndex,
						})}
					>
						{item}
					</MenuItem>
				))}
			</Select>
		</Box>
	);
}
